export default __webpack_public_path__ + "static/arweave-b3df8a6ce95466a85e15805537346b52.svg";